import type { CatalogoRef, ClienteRef, DateOnlyString, Paginated } from '../common';
import type { InvoiceType } from '../cobros';

/** Supported file formats for operational report exports. */
export const CORTE_MORA_EXPORT_FORMAT = {
  PDF: 'pdf',
  XLSX: 'xlsx',
} as const;

export type CorteMoraExportFormat =
  (typeof CORTE_MORA_EXPORT_FORMAT)[keyof typeof CORTE_MORA_EXPORT_FORMAT];

/** Filters shared by the paginated, stats, and export report endpoints. */
export interface CorteMoraFilters {
  search?: string;
  idCliente?: number;
  tipoFactura?: InvoiceType;
  fechaDesde?: DateOnlyString;
  fechaHasta?: DateOnlyString;
}

/** Query contract for the paginated 2+ pending-invoice client report. */
export interface QueryCorteMora extends CorteMoraFilters {
  offset: number;
  limit: number;
}

/** One client candidate returned by the cutoff-by-arrears report. */
export interface CorteMoraClienteRow {
  idCliente: number;
  cliente: ClienteRef;
  estadoCliente: CatalogoRef | null;
  estadosServicio: CatalogoRef[];
  facturasPendientes: number;
  deudaPendiente: string;
  /** Earliest persisted due date; legacy rows use issue date + 15 days. */
  facturaMasAntigua: DateOnlyString | null;
  facturaMasAntiguaPeriodoInicio: DateOnlyString | null;
  facturaMasAntiguaPeriodoFin: DateOnlyString | null;
}

export type CorteMoraResponse = Paginated<CorteMoraClienteRow>;

/** Aggregate values for exactly the same filtered candidate set as the list. */
export interface CorteMoraStatsResponse {
  clientesCandidatos: number;
  facturasPendientes: number;
  deudaPendiente: string;
}
